import { debounce, throttle } from 'lodash';
import { useState } from 'react';
import { useDidMount } from 'common/components/useDidMount';
import { useWillUnmount } from 'common/components/useWillUnmount';

function getSize() {
	return {
		innerHeight: window.innerHeight,
		innerWidth: window.innerWidth,
		outerHeight: window.outerHeight,
		outerWidth: window.outerWidth,
	};
}

type Config = {
	debounce?: number;
	throttle?: number;
};

export function useWindowSize(config: Config = {}) {
	const [windowSize, setWindowSize] = useState(getSize());

	function handleResize() {
		setWindowSize(getSize());
	}

	useDidMount(() => {
		if (config.debounce) {
			window.addEventListener('resize', debounce(handleResize, config.debounce));
		} else if (config.throttle) {
			window.addEventListener('resize', throttle(handleResize, config.throttle));
		} else {
			window.addEventListener('resize', handleResize);
		}
	});

	useWillUnmount(() => {
		window.removeEventListener('resize', handleResize);
	});

	return windowSize;
}
